import { render, staticRenderFns } from "./CreateSuperAdminForm.vue?vue&type=template&id=3540426e&scoped=true"
import script from "./CreateSuperAdminForm.vue?vue&type=script&lang=js"
export * from "./CreateSuperAdminForm.vue?vue&type=script&lang=js"
import style0 from "./CreateSuperAdminForm.vue?vue&type=style&index=0&id=3540426e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540426e",
  null
  
)

export default component.exports